import { proxy } from 'valtio';
export const opkevin_store = proxy({
    chartType: 'profit',
});
